/* global btoa */
import React from "ES/lib/react";
import _ from "ES/lib/lodash";
import qs from "qs";
import AuthedUserSession from "../../utils/AuthedUserSession";

module.exports = function CognitoForm({ login_locked } = {}) {
  const BALBOA_URL = [
    "https://",
    AuthedUserSession.is_privatelabel ? "balboa-st" : "balboa",
    AuthedUserSession.is_staging ? "-staging" : "",
    ".espeakers.com",
  ].join("");

  const state = btoa(
    encodeURIComponent(
      [
        `${window.location.protocol}//${
          window.location.host
        }/balboa3/oauth2/authviaestoken?estoken=[[token]]&redir=/myevents&error_redir=${encodeURIComponent(
          `${window.location.protocol}//${window.location.host}/myevents/signin?cognito=1`
        )}`,
        `${window.location.protocol}//${window.location.host}/myevents/signin?cognito=1&error=[[error]]`,
      ].join("|")
    )
  );

  const error = _.get(
    qs.parse(_.get(window.location, "search", "").replace("?", "")),
    ["error"]
  );

  return (
    <div>
      {login_locked && AuthedUserSession.is_privatelabel ? (
        <a
          className={"btn btn-default btn-block"}
          href={`${BALBOA_URL}/speaker/connect/cognito?state=${state}`}
        >
          CLOSED DURING MAINTENANCE
          <div />
        </a>
      ) : (
        <a
          className={"btn btn-default btn-block"}
          href={`${BALBOA_URL}/speaker/connect/cognito?state=${state}`}
        >
          Secure Sign-in
          <div />
        </a>
      )}
      <br />
      {error && <div className={"alert alert-danger"}>{error}</div>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/signin/CognitoForm.js